/*  MUI  */
import { Box } from '@mui/material';

/*  React  */
import React from 'react';
import { useParams } from 'react-router';

/*  Components  */
import { UserAdmin } from './Pages/Admin/Dashboard';
import { UserLogs } from './Pages/Logs';
import { UserOverview } from './Pages/UserOverview';
import { UserDashboardTabs } from './internal/UserDashboardTabs';
import { UserHeader } from './internal/UserHeader';

export const AdminUserDashboard = () => {
    const { tab } = useParams();
    const activeTab = tab ?? 'overview';

    return (
        <>
            <UserHeader />
            <Box data-testid="adminUserDashboard">
                <UserDashboardTabs />
                {activeTab === 'overview' && <UserOverview />}
                {activeTab === 'admin' && <UserAdmin />}
                {activeTab === 'logs' && <UserLogs />}
            </Box>
        </>
    );
};
